module.exports = __webpack_public_path__ + "static/media/HackleABTest.45aaf0c0.svg";